import React from "react";
import { BookOpenIcon, PresentationIcon, UsersIcon, BrainIcon, EyeIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
const studyHabits = [{
  icon: BookOpenIcon,
  text: "They read papers."
}, {
  icon: PresentationIcon,
  text: "They watch surgical demonstrations."
}, {
  icon: UsersIcon,
  text: "They attend conferences."
}, {
  icon: BrainIcon,
  text: "They study anatomy."
}, {
  icon: EyeIcon,
  text: "They review other surgeons' cases."
}];
const process = ["You take a case.", "You look.", "You think.", "You document your reasoning.", "You compare with the educational review.", "You learn from the difference."];
export function Story() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" aria-labelledby="story-title" data-id="element-236" data-mp="1dtjn7xf84qxl">
      <div className="mx-auto max-w-2xl" data-id="element-237" data-mp="q3z67k2ms3qy">
        <h2 id="story-title" className="text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-238" data-mp="q2xjgic95ste">
          From looking at cases… <em className="text-gold" data-id="element-239" data-mp="l31ot9pg3dqi">to training your reasoning</em>
        </h2>

        <div className="mt-10 space-y-5 text-lg leading-relaxed text-ink/85" data-id="element-240" data-mp="hi0ye3mse51l">
          <p data-id="element-241" data-mp="mg2rlhdxfkqs">For years, I've watched physicians study more and more information about blepharoplasty.</p>
          <ul className="space-y-2.5" data-id="element-242" data-mp="r9f6v0wpuf6v">
            {studyHabits.map(({
            icon: Icon,
            text
          }) => <li key={text} className="flex items-center gap-3 rounded-xl bg-cream px-4 py-3 font-medium" data-id="element-243" data-mp="w5vu7sw3cpiw">
                <Icon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-244" data-mp="3uqdutm3a2nqm" />
                {text}
              </li>)}
          </ul>
          <p data-id="element-245" data-mp="8h33qby8n9vo">And yet, when a new case appears, the same question often comes back:</p>
          <blockquote className="rounded-2xl bg-navy px-6 py-6 text-center font-serif text-2xl font-bold italic text-white sm:text-3xl" data-id="element-246" data-mp="cj7vf554lwfo">
            “What should I be looking at first?”
          </blockquote>
          <p data-id="element-247" data-mp="1ny38wns1drun">I don't think the problem is necessarily a lack of knowledge. Sometimes the missing piece is <strong data-id="element-248" data-mp="3kyqxfaxd1vlv">structured practice</strong>.</p>
          <p data-id="element-249" data-mp="3kxfvlgnh6xxe">
            Because knowing information and knowing how to organize your observations when faced with a new case are{" "}
            <strong data-id="element-250" data-mp="3tzp2zxng6b6k">two different skills.</strong>
          </p>
          <p data-id="element-251" data-mp="3tz5n0mhcxwv6">That's why I created the Blepharoplasty Decision Lab™. Not another 20-hour course. Not another massive textbook. Something you can actually use with cases.</p>
        </div>

        <ol className="mt-8 space-y-0 border-l-2 border-gold/60 pl-6" data-id="element-252" data-mp="31btbr8gndbh6">
          {process.map(step => <li key={step} className="relative py-2 text-lg font-semibold text-ink" data-id="element-253" data-mp="2xaznuf37fwoa">
              <span className="absolute -left-[31px] top-1/2 h-3 w-3 -translate-y-1/2 rounded-full bg-gold ring-4 ring-white" aria-hidden="true" data-id="element-254" data-mp="3b1l7w74eacnr" />
              {step}
            </li>)}
        </ol>

        <p className="mt-10 text-center font-serif text-2xl font-bold leading-snug text-navy" data-id="element-255" data-mp="2iixqp2sirhry">
          One case. About 15 minutes. One opportunity to improve how you think.
        </p>

        <CtaButton label="I want to train with the Decision Lab™" className="mt-8" data-id="element-256" data-mp="t2ldxvbz2a0j" />
      </div>
    </section>;
}